import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { Box, Paper, Typography, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import _ from 'lodash'
import PropTypes from 'prop-types';

import Loading from 'components/ui/Loading'
import SideBar from 'components/ui/Sidebar'
import styles from './styles'
import './styles.css'
import ClimaticEvent from './components/ClimaticEvent'
import TabsMenu from './components/TabsMenu'
import TabPanelNoteContents from './components/TabPanelNoteContents'
import TabPanelHistoricContents from './components/TabPanelHistoricContents'

import { getFieldNotebooks, getHistory, formatArchives, getParams } from 'api/fieldNotebooks'

const useStyles = makeStyles(styles)

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

const FieldNotebooks = ({ t }) => {

  const [loading, setLoading] = useState(false)
  const [archives, setArchives] = useState([{}])
  const [historySelected, setHistorySelected] = useState()
  const [archiveSelected, setArchiveSelected] = useState()
  const [selectedTab, setSelectedTab] = React.useState(0)
  const [isFormSelected, setIsFormSelected] = useState(false)
  const [isHistoricFormSelected, setIsHistoricFormSelected] = useState(false)
  let history = useHistory()
  useEffect(() => {
    const fetchFieldNotebooks = async () => {
      setLoading(true)
      try {
        const { jwt, company_id } = getParams(history.location.search)
        const params = {
          company_id: company_id,
          jwt: jwt
        }
        const { data } = await getFieldNotebooks(params)
        setArchives(formatArchives(data.archives || []))
      } catch (error) {
        console.log(error)
      }

      setLoading(false)
    }
    fetchFieldNotebooks()
  }, [])

  const kinds = [
    { name: t('annotation'), id: 0 },
    { name: t('historic'), id: 1 }
  ]

  const handleChange = selectedTab => {
    setSelectedTab(selectedTab)
    setIsHistoricFormSelected(false)
  }

  const handleArchiveHistorySelected = async (ArchiveId) => {
    setLoading(true)
    try {
      const params = { archive_id: ArchiveId }
      const { data } = await getHistory(params)
      setHistorySelected(data)
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const classes = useStyles()
  const isEmpty = _.isEmpty(archives[0])
  const isSelected = !_.isUndefined(archiveSelected)
  const isHistorySelected = !_.isUndefined(historySelected)

  return (
    <>
      <SideBar />
      <Paper className={classes.page__wrapper} elevation={0}>

        <header className={classes.page__header}>
          <Typography component='h2' variant='h5'>
            {!isSelected ? t('field_notebook') : archiveSelected.name}
          </Typography>
        </header>

        {
          loading
            ? <Loading />
            : isEmpty
              ? <Typography variant='body2'>
                {t('no_archives')}
              </Typography>
              : isSelected
                ?
                <ClimaticEvent
                  classes={classes}
                  isFormSelected={isFormSelected}
                  setArchiveSelected={setArchiveSelected}
                  archiveSelected={archiveSelected}
                  setIsFormSelected={setIsFormSelected}
                />
                :
                <Grid container className={classes.page__form}>
                  <Grid item sm={12} xs={12}>
                    <Typography variant='caption'>
                      {t('field_annotation_category')}
                    </Typography>
                  </Grid>
                  <TabsMenu
                    selectedTab={selectedTab}
                    kinds={kinds}
                    handleChange={handleChange}
                  />
                  <TabPanelNoteContents
                    classes={classes}
                    TabPanel={TabPanel}
                    selectedTab={selectedTab}
                    archives={archives}
                    setArchiveSelected={setArchiveSelected}
                  />
                  <TabPanelHistoricContents
                    classes={classes}
                    TabPanel={TabPanel}
                    selectedTab={selectedTab}
                    isHistorySelected={isHistorySelected}
                    setHistorySelected={setHistorySelected}
                    historySelected={historySelected}
                    archives={archives}
                    handleArchiveHistorySelected={handleArchiveHistorySelected}
                    isHistoricFormSelected={isHistoricFormSelected}
                    setIsHistoricFormSelected={setIsHistoricFormSelected}
                  />
                </Grid>
        }
      </Paper >
    </>
  )

}

export default withTranslation()(FieldNotebooks)